import { useEffect, useRef } from 'react';

const VALID_KEYS_REGEX = new RegExp(
  /^[\wáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ!@#$%^&*(),.?"'`~:;{}|<>\-_=+[\]\\/ ]$/,
);

export default (callback, options = {}) => {
  const { preventEnterDefault = true, disabled = false } = options;
  const callbackRef = useRef();

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    let isMounted = true;

    if (!disabled) {
      let inputValue = '';

      const handleInput = e => {
        const { key } = e || {};

        if (isMounted) {
          if (key === 'Enter') {
            const callbackFn = callbackRef.current;

            if (callbackFn && typeof callbackFn === 'function') {
              callbackFn(inputValue);
            }

            inputValue = '';

            if (preventEnterDefault) {
              e.preventDefault();
            }
            return;
          }
          if (key && VALID_KEYS_REGEX.test(key)) {
            inputValue = `${inputValue}${key}`;
          }
        } else {
          inputValue = '';
        }
      };

      window.addEventListener('keydown', handleInput);

      return () => {
        isMounted = false;
        window.removeEventListener('keydown', handleInput);
      };
    }

    return () => null;
  }, [preventEnterDefault, disabled]);
};
